var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24ZM12 1.71429C17.6571 1.71429 22.2857 6.34286 22.2857 12C22.2857 17.6571 17.6571 22.2857 12 22.2857C6.34286 22.2857 1.71429 17.6571 1.71429 12C1.71429 6.34286 6.34286 1.71429 12 1.71429Z",
    fill: "#BF152C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M22.2858 11.9967C22.2858 6.33951 17.6572 1.71094 12.0001 1.71094C6.34293 1.71094 1.71436 6.33951 1.71436 11.9967C1.71436 17.6538 6.34293 22.2824 12.0001 22.2824C17.6572 22.2824 22.2858 17.6538 22.2858 11.9967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "!",
    d: "M10.7792 14.36L10.3792 4.5H13.5792L13.1792 14.36H10.7792ZM10.1992 17.64C10.1992 16.68 10.9992 15.88 11.9792 15.88C12.9392 15.88 13.7392 16.68 13.7392 17.64C13.7392 18.62 12.9392 19.42 11.9792 19.42C10.9992 19.42 10.1992 18.62 10.1992 17.64Z",
    fill: "#BF152C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.dc17116c874846418573b67139ae4fc2.svg";
export { ForwardRef as ReactComponent };